<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" ref="searchForm" label-width="85px">
        <el-form-item label="质检条目">
          <el-select v-model="form.checkCategory" placeholder="请选择" filterable clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in checkCategoryList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="违规项">
          <el-select v-model="form.categoryDetail" placeholder="请选择" filterable clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in categoryDetailList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场景">
          <el-select v-model="form.scene" placeholder="请选择" filterable clearable @change="onSearch">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in sceneList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add">新增</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        :span-method="objectSpanMethod"
        :height="maxTableHeight"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="loading"
      >
        <el-table-column label="质检条目" prop="checkCategory"></el-table-column>
        <el-table-column label="违规项" prop="categoryDetail"></el-table-column>
        <el-table-column label="场景" prop="scene"></el-table-column>
        <el-table-column label="扣分" prop="assessmentScore"></el-table-column>
        <el-table-column label="生效时间" prop="effectDate"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scoped">
            <span :style="`color: ${scoped.row.status == '停用' ? 'red' : ''}`">{{scoped.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" :style="`color: ${scoped.row.status == '启用' ? 'red' : '#0BB78E'}`" @click="statusType(scoped.row)">{{
              scoped.row.status == "启用" ? "停用" : "启用"
            }}</el-link>
            <el-link type="primary" :underline="false" @click="log(scoped.row)">调整记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-dialog :visible.sync="dialogVisible" @success="onSearch" v-if="dialogVisible"></add-dialog>
    <edit-dialog :visible.sync="isShowEdit" :rowData="rowData" @success="onSearch" v-if="isShowEdit"></edit-dialog>
    <operation-log :visible.sync="isShowLog" :rowData="rowData" v-if="isShowLog"></operation-log>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import addDialog from "./components/add.vue";
import editDialog from "./components/edit.vue";
import tableMixin from "@/utils/tableMixin";
import operationLog from "./components/operationLog.vue"

export default {
  mixins: [tableMixin],
  components: { addDialog, editDialog, operationLog },
  data() {
    return {
      form: {
        checkCategory: "",
        categoryDetail: "",
        scene: "",
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      isShowEdit: false,
      dialogConfig: {},
      rowData: {},
      searchFormData: [],
      authOptionsList: [],
      //质检条目
      checkCategoryList: [],
      //违规项
      categoryDetailList: [],
      //场景
      sceneList: [],
      spanIndex: 0,
      spanIndex2: 0,
      spanMap: {},
      loading: false,
      isShowLog: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.$set(this.form, "storeId", "");
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "checkCategory", //质检条目
          val: [this.form.checkCategory ? this.form.checkCategory : ""],
          op: "in",
        },
        {
          attributeName: "categoryDetail", //违规项
          val: [this.form.categoryDetail ? this.form.categoryDetail : ""],
          op: "in",
        },
        {
          attributeName: "scene", //场景
          val: [this.form.scene ? this.form.scene : ""],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "qualityCheckProjectConfig";
      data.queryMatch = filter || [];
      data.hasCount = "Y";
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/qualityCheckProjectConfig`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.computeSpanData(res.data.list);
          }
        })
        .finally(() => {
          this.loading = false;
          this.updateSeachSlect();
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {
        checkCategory: "",
        categoryDetail: "",
        scene: "",
      };
      this.onSearch();
    },
    //质检条目
    getCheckCategory() {
      let data = { ...this.currencyForm };
      data.reportCode = "qualityCheckProjectConfig";
      data.groupAttr = "checkCategory";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.checkCategoryList = data;
      });
    },
    //违规项
    getCategoryDetail() {
      let data = { ...this.currencyForm };
      data.reportCode = "qualityCheckProjectConfig";
      data.groupAttr = "categoryDetail";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.categoryDetailList = data;
      });
    },
    //场景
    getScene() {
      let data = { ...this.currencyForm };
      data.reportCode = "qualityCheckProjectConfig";
      data.groupAttr = "scene";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.sceneList = data;
      });
    },
    // 新增 弹出dialog
    add() {
      this.rowData = null;
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.isShowEdit = true;
    },
    //调整记录
    log(row) {
      this.rowData = row
      this.isShowLog = true
    },
    async statusType(row) {
      let statusText = row.status == "启用" ? "停用" : "启用";
      let status = await this.$confirm(`是否确认${statusText}？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.qualityTestingManage.projectConfigUpdateStatus({ fragment: [row.dataId] });
      if (res.success) {
        this.$message.success(`${statusText}成功`);
      } else {
        this.$message.fail(`${statusText}失败`);
      }
      this.onSearch();
    },
    updateSeachSlect() {
      this.getCheckCategory();
      this.getCategoryDetail();
      this.getScene();
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanMap[index] = {
          level1: 1,
          level2: 1,
        };
        this.spanIndex = 0;
        this.spanIndex2 = 0;
      } else {
        // 一级合并
        if (data[index].checkCategory === data[index - 1].checkCategory) {
          let spanRow = this.spanMap[this.spanIndex];
          spanRow.level1 += 1;
          // 二级合并
          let level2 = 1;
          if (data[index].categoryDetail === data[index - 1].categoryDetail) {
            spanRow = this.spanMap[this.spanIndex2];
            spanRow.level2 += 1;
            // 当前行参与二级合并，当前行level2 = 0
            level2 = 0;
          } else {
            this.spanIndex2 = index;
          }
          this.spanMap[index] = {
            level1: 0,
            level2,
          };
        } else {
          this.spanMap[index] = {
            level1: 1,
            level2: 1,
          };
          this.spanIndex = index;
          this.spanIndex2 = index;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      const spanRow = this.spanMap[rowIndex];
      if (!spanRow) {
        return;
      }

      if (columnIndex == 0) {
        return {
          rowspan: spanRow.level1,
          colspan: 1,
        };
      }
      // 二级合并的列
      if (columnIndex == 1) {
        return {
          rowspan: spanRow.level2,
          colspan: 1,
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
